
$(window).on('load',() => {
  (()=>{
    $(document).ready(() =>{
      $(document).on("swell:initialized",() => {
        console.log("swell initialized");
        //new RedemptionTable(spapi.activeRedemptionOptions).renderRedemptions();
        
        
      });

      $(document).on("swell:setup",() => {
        console.log("swell setup");
        
       let vipTiersOrder = swellAPI.getVipTiers().sort((a, b) => a.swellrequiredAmountSpentCents - b.swellrequiredAmountSpentCents);
       console.log(vipTiersOrder);
        new VipTiers(
            vipTiersOrder,
            loyaltyConstants.vipTiers.currentStatusLabel,
            loyaltyConstants.vipTiers.benefitHeaders,
            loyaltyConstants.vipTiers.benefitHeadersTitle,
            loyaltyConstants.vipTiers.benefitsList,
            swellAPI.getCustomerDetails()
          ).renderVipTiers();

      });
    });
  }).call(this);
})
